import React from 'react';
import Select from 'react-select';
import { Col, Label, Row } from 'reactstrap';
import { BASE_URL, ERROR_RCTI_STATUS_ID } from '../../constants';
import { displayAddressFormater, displayDateFormater, getPrimaryOrSecondaryAddress, mustBeArray } from '../../utils/lib';
import {Link} from "react-router-dom";

const RebatesRCTIBasicDetail = props => {
    const {rctiDetails, handleRCTIStatusChange, rctiStatus, rctiStatusOptions, editMode} = props;
    return(
        <React.Fragment>
            <Row>
                <Col sm={12} md={8} lg={6}>
                    <Row className="align-items-center mb-h mt-2">
                        <Col sm={4} md={3}>
                            <Label className="mt-h">RCTI No</Label>
                        </Col>
                        <Col sm={8} md={9}>
                            {(rctiDetails && rctiDetails.rctiNumber)}
                        </Col>
                    </Row>
                    <Row className="align-items-center mb-h">
                        <Col sm={4} md={3}>
                            <Label className="mt-h">RCTI Date</Label>
                        </Col>
                        <Col sm={8} md={9}>
                            {displayDateFormater({value: rctiDetails && rctiDetails.dateCreated})}
                        </Col>
                    </Row>
                    <Row className="align-items-center mb-h">
                        <Col sm={4} md={3}>
                            <Label className="mt-h">Client Name</Label>
                        </Col>
                        <Col sm={8} md={9}>
                           <Link target="_blank" to={`${BASE_URL}/manage/clients/${rctiDetails && rctiDetails.clientID}`}> {(rctiDetails && rctiDetails.clientName)}</Link>
                        </Col>
                    </Row>
                    <Row className="align-items-center mb-h">
                        <Col sm={4} md={3}>
                            <Label className="mt-h">Billing Address</Label>
                        </Col>
                        <Col sm={8} md={9}>
                            {displayAddressFormater({
                                address: getPrimaryOrSecondaryAddress({clientAddresses: rctiDetails && rctiDetails.payToClient ? 
                                                                            rctiDetails.clientAddresses : rctiDetails && rctiDetails.locationAddresses}) 
                            })}
                        </Col>
                    </Row>
                    <Row className="align-items-center mb-1 ">
                        <Col sm={4} md={3}>
                            <Label for="rctiStatus" className="mt-h">Export Status</Label>
                        </Col>
                        <Col sm={8} md={9}>
                            {
                                !editMode ?
                                (rctiDetails && rctiDetails.exportStatusName) :
                                <Select
                                    defaultValue={1}
                                    name="statusID"
                                    value={rctiStatus}
                                    multi={false}
                                    clearable={false}
                                    simpleValue={true}
                                    options={mustBeArray(rctiStatusOptions)}
                                    onChange={handleRCTIStatusChange}
                                    valueKey="id"
                                    labelKey="name"
                                />
                            }
                        </Col>
                    </Row>
                    {
                        rctiDetails && rctiDetails.exportStatusID === ERROR_RCTI_STATUS_ID &&
                        <React.Fragment>
                            {
                                rctiDetails.exportErrorMessage && 
                                <Row className="align-items-center mb-h text-danger">
                                    <Col sm={4} md={3}>
                                        <Label for="rctiStatus" className="mt-h">Export Error</Label>
                                    </Col>
                                    <Col sm={8} md={9} >
                                        {rctiDetails.exportErrorMessage}
                                    </Col>
                                </Row>
                            }
                            {
                                rctiDetails.supplierErrorMessage && 
                                <Row className="align-items-center mb-1 text-danger">
                                    <Col sm={4} md={3}>
                                        <Label for="rctiStatus" className="mt-h">Supplier Error</Label>
                                    </Col>
                                    <Col sm={8} md={9} >
                                        {rctiDetails.supplierErrorMessage}
                                    </Col>
                                </Row>
                            }
                        </React.Fragment>
                    }
                </Col>
            </Row>
        </React.Fragment>
    );
};

export default RebatesRCTIBasicDetail;